import { ICompanyContract, ICompanySearchRequest } from '../contracts/Company';
import { getDataAsync, postDataAsync, putDataAsync } from '../ZeosApiExecutor';
import { ICompanyCollection } from './interfaces/ICompany';

let companyPrefix = "/Company/";

export const Company: ICompanyCollection = {
  getCompanyAsync: async (companyId: number) => {
    const response = await getDataAsync<ICompanyContract>(
      `${companyPrefix}get/${companyId}`,
      "Company"
    );
    return response;
  },
  postCompanyAsync: async (data: ICompanyContract) => {
    const response = await postDataAsync<void>(`${companyPrefix}create`, data);
    return response;
  },
  postCompaniesBatchAsync: async (data: ICompanyContract[]) => {
    const response = await postDataAsync<ICompanyContract[]>(
      `${companyPrefix}create-batch`,
      data
    );
    return response;
  },
  putCompanyAsync: async (data: ICompanyContract) => {
    const response = await putDataAsync<void>(`${companyPrefix}update`, data);
    return response;
  },
  companiesByCustIdAsync: async (customerId: number) => {
    const response = await getDataAsync<ICompanyContract[]>(
      `${companyPrefix}customer/${customerId}`,
      "Companies"
    );
    return response;
  },
  searchCompaniesAsync: async (request: ICompanySearchRequest) => {
    const response = await postDataAsync<ICompanyContract[]>(
      `${companyPrefix}search`,
      request
    );
    return response;
  },
};
